import { render, staticRenderFns } from "./NumManage.vue?vue&type=template&id=f4f09e86&scoped=true"
import script from "./NumManage.vue?vue&type=script&lang=js"
export * from "./NumManage.vue?vue&type=script&lang=js"
import style0 from "./NumManage.vue?vue&type=style&index=0&id=f4f09e86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f09e86",
  null
  
)

export default component.exports